<template>
  <div>
    <v-row>
      <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
        <v-text-field
          label="Search Here"
          v-model="searchQuery"
          class="py-0 my-0"
        ></v-text-field>
      </v-col>
      <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
        <v-select
          :items="searchOptions"
          v-model="selectedSearchOption"
          item-value="value"
          item-text="text"
          return-object
          class="py-0 my-0"
        ></v-select>
      </v-col>
    </v-row>
    <!-- <v-flex class="px-2" xs12 sm2 md2>
        <v-btn color="primary" @click="search">Search</v-btn>
    </v-flex>-->
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1"
      :options.sync="pagination"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="footerProps"
    >
      <template v-slot:item.actions="{ item }">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import _ from "lodash";
const API_ENDPOINT = "/api/earnDeduc/GetAllowanceEarnings";
export default {
  data: () => ({
    pagination: {
      page: 1,
      pageSize: 10
    },
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "code",
        sortable: true
      },
      {
        text: "Description",
        value: "description",
        sortable: true
      }
    ],
    selectedSearchOption: {},
    searchQuery: "",
    searchBy: "",
    totalItems: 0,
    items: [],
    footerProps: {
      itemsPerPageOptions: [5, 10, 25, 50]
    },
    searchOptions: [
      {
        text: "Code",
        value: "earnCode"
      },
      {
        text: "Description",
        value: "earnDesc"
      }
    ],
    loading: false
  }),
  methods: {
    getAll() {
      this.loading = true;
      const { page, pageSize, sortBy, sortDesc } = this.pagination;

      const pageNumber = this.searchQuery == "" ? page : 1;
      let sort = "";

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          sort = "desc";
        } else {
          sort = "asc";
        }
      }

      this.$axios
        .get(
          `${API_ENDPOINT}?pageNumber=${pageNumber}&pageSize=${pageSize}&searchBy=${this.searchBy}&searchQuery=${this.searchQuery}&orderBy=${sortBy}&sort=${sort}`
        )
        .then(({ data }) => {
          this.items = data;

          if (!_.isEmpty(data)) {
            this.totalItems = data[0].totalRecords;
          } else {
            this.totalItems = 0;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      const { value } = this.selectedSearchOption;
      this.searchBy = value;

      this.getAll();
    }
  },
  watch: {
    searchQuery() {
      setTimeout(() => {
        this.search();
      }, 500);
    },
    selectedSearchOption() {
      this.search();
    }
  },
  mounted() {
    this.selectedSearchOption = this.searchOptions[0];
  }
};
</script>
